import React from "react";
import { values } from "ramda"
import { thStyles } from "../../common/styles";
import Label from "../../common/components/Label";
import EquityRecommendationLeg from "./EquityRecommendationLeg";
import FixedIncomeRecommendationLeg from "./FixedIncomeRecommendationLeg";
import FxRecommendationLeg from "./FxRecommendationLeg";
import { SEARCH_UNIVERSE } from "../constants";
import { DIRECTION } from "../../common/constants";
import { instrumentWith } from "../models";


const recommendationLegInitialValues = () => ({
    direction: DIRECTION.BUY,
    instrument: instrumentWith()
});

const labelForSearchUniverse = {
    [SEARCH_UNIVERSE.FIXED_INCOME]: "Instrument or Issuer",
    [SEARCH_UNIVERSE.EQUITY]: "Stock",
    [SEARCH_UNIVERSE.FX]: "Currency Pair"
};

const descriptionLabelForSearchUniverse = {
    [SEARCH_UNIVERSE.FIXED_INCOME]: "Further Details",
    [SEARCH_UNIVERSE.EQUITY]: "Derivative",
    [SEARCH_UNIVERSE.FX]: "Derivative Details"
};

const RecommendationLegs = (props) => {
    const searchUniverse = props.recommendation.searchUniverse.value;

    let recommendationLegs;
    switch (searchUniverse) {
        case SEARCH_UNIVERSE.FIXED_INCOME:
            recommendationLegs = props.recommendation.legs.map((leg, idx) =>
                <FixedIncomeRecommendationLeg key={idx} {...leg} onRemoveLeg={ () => props.recommendation.legs.removeField(idx) }/>
            );
            break;
        case SEARCH_UNIVERSE.EQUITY:
            recommendationLegs = props.recommendation.legs.map((leg, idx) =>
                <EquityRecommendationLeg key={idx} {...leg} onRemoveLeg={ () => props.recommendation.legs.removeField(idx) }/>
            );
            break;
        case SEARCH_UNIVERSE.FX:
            recommendationLegs = props.recommendation.legs.map((leg, idx) =>
                <FxRecommendationLeg key={idx} {...leg} onRemoveLeg={ () => props.recommendation.legs.removeField(idx) }/>
            );
            break;
    }

    return (
        <div>
            <table style={{marginBottom: "0.5em"}}>
                <thead>
                <tr>
                    <th style={thStyles}><Label>Dir.</Label></th>
                    <th className="x-instrument-label" style={thStyles}>
                        <Label>{labelForSearchUniverse[searchUniverse]}</Label>
                    </th>
                    <th className="x-leg-description-label" style={thStyles}><Label>{ descriptionLabelForSearchUniverse[searchUniverse] }</Label></th>
                    <th style={thStyles}><Label>Market Price</Label></th>
                    <th style={thStyles}><Label>Target Price</Label></th>
                    <th style={thStyles}></th>
                </tr>
                </thead>

                <tbody>
                    { recommendationLegs }
                </tbody>
            </table>

            <button type="button"
                    className="pure-button"
                    onClick={ () => props.recommendation.legs.addField(recommendationLegInitialValues()) } >Add Leg</button>
        </div>
    );
};

export default RecommendationLegs


/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/RecommendationLegs.js
 **/